<template>
  <el-dialog
    class="modal-batch-account"
    :title="title"
    :visible.sync="visible"
    @close="$_cancle"
    lock-scroll
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    custom-class="greater"
  >
    <div class="content">
      <el-form
        ref="batchAccount"
        :rules="rules"
        v-loading="isLoading"
        label-position="right"
        :model="formData"
        @submit.native.prevent
        class="batch-account__form"
      >
        <el-form-item label="所属运营商:">
          <el-input :disabled="true" v-model="modalData.dataObj[0].orgName" style="width: 291px;">
          </el-input>
        </el-form-item>

        <el-form-item label="接收结果邮箱:" prop="emails" type="textarea" style="margin-bottom: 0;">
          <el-input
            type="textarea"
            style="width: 500px; height: 48px;"
            resize="none"
            placeholder="必填"
            v-model="formData.emails"
          ></el-input>
          <span class="input-tips">*最多输入20个邮箱地址, 多个用", "隔开</span>
        </el-form-item>

        <el-form-item label class="download_btn">
          <span>请下载批量新增模板, 编辑后选择对应导入文件点击"上传"生成</span>
          <el-button @click="$_download" class="select__btn">下载导入模板</el-button>
        </el-form-item>

        <el-form-item label prop="filename" class="download_btn">
          <label for="upload">
            <span
              v-show="formData.filename === ''"
              class="filename__span el-input__inner placeholder"
            >上传的文件, 仅支持*.xls或*.xlsx的文件类型</span>
            <span
              v-show="formData.filename !== ''"
              class="filename__span el-input__inner"
            >{{formData.filename}}</span>

            <input
              type="file"
              ref="fileInput"
              @change="$_selectFile"
              name="upload"
              id="upload"
              accept=".xls, .xlsx"
              style="display: none;"
            />
            <span class="select-btn__span">选择文件</span>
          </label>
          <el-button @click="$_upload" class="select__btn">上传</el-button>
          <div class="tips-txt">
            *单次导入数据量最多为
            <span style="color:#EA2A2A">1000</span>条,请按以下字段规则填写。若不符合规则,将导致导入失败。
          </div>
        </el-form-item>

        <el-form-item>
          <div class="systems-config">
            <table class="systems-config__table">
              <thead>
                <tr style="background:rgba(232,236,239,1);">
                  <th width="120px">字段</th>
                  <th>说明</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in formData.fieldRules" :key="index">
                  <td>
                    <span>{{item.field}}</span>
                  </td>
                  <td>
                    <span>{{item.explain}}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </el-form-item>
      </el-form>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button class="cancel__btn" @click="$_cancle">放弃</el-button>
    </div>
  </el-dialog>
</template>
<script>
import XLSX from "xlsx";
import * as Utils from "@/plugins/utils";

export default {
  name: "modal-modify-account",
  props: {
    title: { type: String, default: "" },
    modalData: { type: Object, default: {} }
  },
  data() {
    return {
      visible: false,
      isLoading: false,
      formData: {
        emails: "",
        filename: "",
        importOrgList: [],
        fieldRules: [
          {
            field: "上级组织ID",
            explain: "必填，PaaS中的组织ID，一行数据仅允许填写一个上级组织ID；"
          },
          {
            field: "上级组织名称",
            explain:
              "必填，PaaS中的组织名称，一行数据仅允许填写一个上级组织名称；"
          },
          {
            field: "组织名称",
            explain:
              "必填，支持输入最多32个字符，格式不限；一行数据仅允许填写一个组织名称；"
          },
          {
            field: "组织编码",
            explain:
              "选填，字符长度和格式不限；一行数据仅允许填写一个组织编码；"
          },
          {
            field: "负责人",
            explain:
              "必填，单个负责人支持输入最多32个字符, 多个可用英文“,”隔开；"
          }
        ]
      },
      modal: {
        show: false,
        title: "",
        template: "",
        data: {}
      },
      rules: {
        emails: [
          { required: true, message: "请输入邮箱地址" },
          {
            validator: (rule, value, callback) => {
              if (value) {
                if (value.match(/\w.*,{2,}/) || value.match(/^[,].*/)) {
                  callback(new Error(`请输入正确的邮箱地址, 格式:"名称@域名"`));
                } else {
                  let emails = value.split(",").filter(email => email != "");
                  if (emails.length > 20) {
                    callback(new Error(`最多可输入20个邮箱地址!`));
                  }
                  const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

                  let hasError = emails.some(item => {
                    return item.replace(/\s*/, "").match(reg) === null;
                  });

                  if (hasError) {
                    callback(
                      new Error(`请输入正确的邮箱地址, 格式:"名称@域名"`)
                    );
                  } else {
                    callback();
                  }
                }
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        filename: [{ required: true, message: "请上传需要导入的文件" }]
      }
    };
  },
  methods: {
    // 下载模板
    $_download() {
      const DATA = [
        [
          "上级组织ID（必填）",
          "上级组织名称（必填）",
          "组织名称（必填）",
          "组织编码（选填）",
          "负责人（选填）"
        ]
      ];
      const ws = XLSX.utils.aoa_to_sheet(DATA);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "批量导入组织列表");
      XLSX.writeFile(wb, "批量导入组织列表.xlsx");
    },

    $_clearSelectedFile() {
      this.$refs["fileInput"].value = "";
      this.formData.filename = "";
      this.formData.importOrgList.splice(0);
    },

    // 选择文件
    $_selectFile(event) {
      const self = this;
      const files = event.target.files;
      if (!files || files.length === 0) return false;
      const file = files[0];
      const filename = file.name;
      let fileType = filename.replace(/([^\.]+\.)+(\S+)/g, "$2");

      if (!~["xls", "xlsx"].indexOf(fileType)) {
        $MessageBox.alert({
          content: "文件格式错误!",
          onOk() {
            self.$_clearSelectedFile();
          }
        });
        return false;
      }
      let fileSize = file.size / 1024 / 1024;
      if (fileSize > 1) {
        $MessageBox.alert({
          content: "上传失败，上传的文件超过限制的值（1M）,请重试!",
          onOk() {
            self.$_clearSelectedFile();
          }
        });
        return false;
      }
      const reader = new FileReader();
      reader.onload = e => {
        const bstr = e.target.result;
        try {
          XLSX.read(bstr, { type: "binary" });
        } catch (error) {
          $MessageBox.alert({
            content: "读取文件失败!",
            onOk() {
              self.$_clearSelectedFile();
            }
          });
          return false;
        }
        const wb = XLSX.read(bstr, { type: "binary" });

        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
        if (data.length > 1000) {
          $MessageBox.alert({
            content: "上传失败，上传的数据不能超过1000条!",
            onOk() {
              self.$_clearSelectedFile();
            }
          });
          return false;
        }
        const header = data[0].concat([]);

        if (
          header.length !== 5 ||
          header[0] !== "上级组织ID（必填）" ||
          header[1] !== "上级组织名称（必填）" ||
          header[2] !== "组织名称（必填）" ||
          header[3] !== "组织编码（选填）" ||
          header[4] !== "负责人（选填）"
        ) {
          $MessageBox.alert({
            content: "上传文件表头不符合模板要求，请修改后重新上传!",
            onOk() {
              self.$_clearSelectedFile();
            }
          });
          return false;
        }
        this.formData.filename = filename;
        data.shift();

        this.formData.importOrgList = data
          .map(item => {
            if (typeof item[0] === "undefined") {
              item[0] = "";
            }
            if (typeof item[1] === "undefined") {
              item[1] = "";
            }
            if (typeof item[2] === "undefined") {
              item[2] = "";
            }
            if (typeof item[3] === "undefined") {
              item[3] = "";
            }
            if (typeof item[4] === "undefined") {
              item[4] = "";
            }
            return {
              parentName: item[1] + "",
              parentIdStr: item[0] + "",
              orgName: item[2] + "",
              orgCode: item[3] + "",
              leader: item[4] + ""
            };
          })
          .filter(
            item =>
              !(
                item.parentName === "" &&
                item.parentIdStr === "" &&
                item.orgName === "" &&
                item.orgCode === "" &&
                item.leader === ""
              )
          );
      };
      reader.readAsBinaryString(file);
    },
    // 点击上传按钮
    $_upload() {
      this.$refs["batchAccount"].validate(valid => {
        if (valid) {
          const self = this;

          if (
            this.formData.filename !== "" &&
            this.formData.importOrgList.length > 0
          ) {
            let { platformKey, emails, importOrgList } = this.formData;
            let emailsArr = emails.split(",");
            this.isLoading = true;
            this.$service
              .post("batchImportOrg", {
                platformKey: this.modalData.dataObj[0].platformKey,
                emails: emailsArr,
                importOrgList
              })
              .then(result => {
                if (result.$.checkResult(result, true)) {
                  $MessageBox.alert({
                    content: result.msg,
                    onOk() {
                      self.$emit("callback");
                    }
                  });
                }
                this.isLoading = false;
              });
          } else {
            $MessageBox.alert({ content: "请上传需要导入的文件!" });
          }
        }
      });
    },

    $_submit() {
      this.$refs["batchAccount"].validate(valid => {
        if (valid) {
          const self = this;
          self.isLoading = true;
        }
      });
    },
    $_cancle() {
      this.visible = false;
      this.$emit("close");
    }
  },
  created() {
  },
  mounted() {
    this.visible = true;
  }
};
</script>

<style lang="scss" scoped>
.batch-account__form {
  padding: {
    left: 20px;
  }
}
.content {
  padding: 20px 20px;
  color: #535353;
  .title {
    height: 32px;
    color: #384e8c;
    font-size: 14px;
    font-weight: 700;
  }
}
.filename__span {
  position: relative;
  font-size: 12px;
  width: 291px;
  vertical-align: middle;
  &.placeholder {
    color: #aaa;
  }
}
.select__btn,
.select-btn__span {
  margin-left: 8px;
}
.select-btn__span {
  display: inline-block;
  border-radius: 2px;
  background-color: #1895dd;
  min-width: 64px;
  height: 26px;
  text-align: center;
  line-height: 26px;
  white-space: nowrap;
  cursor: pointer;
  color: #fff;
}
.tips-txt {
  color: #535353;
  margin: {
    top: 15px;
  }
}
/deep/ .download__btn {
  display: inline-block;
  border-radius: 2px;
  background-color: #1895dd;
  min-width: 64px;
  height: 26px;
  text-align: center;
  line-height: 26px;
  white-space: nowrap;
  cursor: pointer;
  color: #fff;
  padding: 0px 6px;
  margin-left: 8px;
}

.systems-config__table {
  border-collapse: collapse;
  width: 764px;
  border: 1px solid rgba(232, 232, 232, 1);
  .has-config__btn,
  .not-config__btn {
    width: 80px;
    height: 30px;
  }
  tr {
    border: 1px solid rgba(232, 232, 232, 1);
  }
  th {
    line-height: 18px;
    padding: 5px 15px;
    font-weight: bold;
    color: #3a3a3a;
  }
  td {
    padding: 10px 15px;
    color: #606060;
  }
}
.input-tips {
  vertical-align: top;
  margin-left: 10px;
}
.download_btn {
  margin-top: 20px;
}
/deep/ .el-form-item[type="textarea"] .el-form-item__error {
  top: 48px;
}
</style>


